module.exports = __webpack_public_path__ + "img/MidSectionImage2.a28a44ab.jpg";